// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../css-global/colors.scss\"","White":"#ffffff","helpWanted":"Footer-module--helpWanted--XR8WE"};